/**
* Created : 24/01/2021 
*/
export default class TwitchMessageType {
	
	public static PLAYLISTS:string = "PLAYLISTS";
	public static ROUND_STATE:string = "ROUND_STATE";
	public static CHANGE_VOLUME:string = "CHANGE_VOLUME";
	public static LEADERBOARD:string = "LEADERBOARD";
	public static BROADCASTER_CONTROL:string = "BROADCASTER_CONTROL";
	public static SET_ZOOM_LEVEL:string = "SET_ZOOM_LEVEL";
	public static SET_TRACK_PLAY_STATE:string = "SET_TRACK_PLAY_STATE";

}